// The «New: clients» banner on the home page (BL-194, ADR-0062). The pre-render shows it (visible without JavaScript);
// the first client render equals the build's (ADR-0050): the stored «closed» and the signed-in link are read only after
// hydration. A visitor who closed it earlier never sees it flash: the inline script in index.html marks <html> before
// paint and CSS hides the build markup, so nothing moves when React then removes it.
import { useState } from "react";
import { Link } from "react-router";
import { t } from "../i18n";
import { useHydrated } from "../hydrated";
import { CLIENTS_WORD } from "../lib";
import { useSession } from "../session";
import { XIcon } from "./icons";

/** localStorage key; index.html reads the same key before paint. */
export const CLIENTS_BANNER_KEY = "mk-banner-clients";

function storedClosed(): boolean {
  try {
    return localStorage.getItem(CLIENTS_BANNER_KEY) === "closed";
  } catch {
    return false;
  }
}

export function ClientsBanner() {
  const hydrated = useHydrated();
  const { me } = useSession();
  const [closedNow, setClosedNow] = useState(false);
  if (closedNow || (hydrated && storedClosed())) return null;

  const signedIn = hydrated && Boolean(me);
  const close = () => {
    try {
      localStorage.setItem(CLIENTS_BANNER_KEY, "closed");
    } catch {
      // private mode: closed for this page view only
    }
    setClosedNow(true);
  };

  return (
    <aside className="clients-banner" aria-label={t("clientsBanner.label")} data-testid="clients-banner">
      <span className="clients-banner-new">{t("clientsBanner.new")}</span>
      <p className="clients-banner-text">
        {t("clientsBanner.text", { count: CLIENTS_WORD })}{" "}
        <Link className="clients-banner-link" to={signedIn ? "/connections" : "/for-agencies"} data-testid="clients-banner-link">
          {t(signedIn ? "clientsBanner.userLink" : "clientsBanner.guestLink")}&nbsp;→
        </Link>
      </p>
      <button type="button" className="clients-banner-close" aria-label={t("clientsBanner.close")} onClick={close} data-testid="clients-banner-close">
        <XIcon size={16} />
      </button>
    </aside>
  );
}
